import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import FeedbackWidget from '../components/FeedbackWidget';

// Hàm helper parse JWT
const parseJwt = (token) => {
    try {
      if (!token) return null;
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      return JSON.parse(jsonPayload);
    } catch (e) { return null; }
};

export default function CandidateLayout() {
  const token = localStorage.getItem('skillmatch_token');
  const user = parseJwt(token);

  // Nếu không phải candidate (hoặc chưa login), đá về trang login
  if (!user || !user.user || user.user.role !== 'candidate') {
    return <Navigate to="/login" replace />;
  }

  return (
    // 1. Sửa màu nền thành #F3F4F6 cho đồng bộ với Business
    <div className="flex flex-col min-h-screen bg-[#F3F4F6] font-sans text-gray-900">
      
      <Navbar /> 
      
      {/* 2. SỬA QUAN TRỌNG: 
         - Bỏ 'max-w-7xl mx-auto px-4...' để nội dung (như Banner) có thể tràn viền.
         - Sửa 'pt-24' thành 'pt-[80px]' (chiều cao Navbar) để nội dung sát lên trên hơn.
      */}
      <main className="flex-1 w-full pt-[80px]">
          <div className="animate-fade-in-up h-full">
              <Outlet />
          </div>
      </main>

      <Footer />
      <FeedbackWidget />

      <style>{`
        @keyframes fadeInUp {
            from { opacity: 0; transform: translateY(10px); }
            to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in-up {
            animation: fadeInUp 0.4s ease-out forwards;
        }
      `}</style>
    </div>
  );
}